module.exports = __webpack_public_path__ + "img/icon_send-email.312b65ec.svg";